import React from 'react';
import type { FileFilters } from '../../../../types/file.types';
import { FilterGroup } from './components/FilterGroup';
import { FilterOption } from './components/FilterOption';
import { FILTER_GROUPS, STANDALONE_FILTERS } from './config/filterOptions';
import { FilterContainer } from './components/base/FilterContainer';
import { FilterHeader } from './components/base/FilterHeader';
import { FilterResetButton } from './components/base/FilterResetButton';
import { FilterContent } from './components/base/FilterContent';

interface FileListFiltersProps {
  filters: FileFilters[];
  handleToggleFilter: (filter: FileFilters) => void;
  filterRef: React.RefObject<HTMLDivElement>;
  resetFilters: () => void;
}

export const FileListFilters = ({
  filters,
  handleToggleFilter,
  filterRef,
  resetFilters,
}: FileListFiltersProps) => {
  const [rotationCount, setRotationCount] = React.useState(0);
  const [isHovered, setIsHovered] = React.useState(false);

  const handleResetClick = () => {
    setRotationCount((prev) => prev + 1);
    resetFilters();
  };

  const getRotation = () => {
    const baseRotation = rotationCount * 360;
    const hoverRotation = isHovered ? 45 : 0;
    return `rotate(${baseRotation + hoverRotation}deg)`;
  };

  return (
    <FilterContainer filterRef={filterRef} onClick={(e) => e.stopPropagation()}>
      <FilterHeader title="Filtrer">
        <FilterResetButton
          onClick={handleResetClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          rotation={getRotation()}
        />
      </FilterHeader>
      <FilterContent>
        {FILTER_GROUPS.map((group) => (
          <FilterGroup
            key={group.title}
            title={group.title}
            options={group.options}
            selectedFilters={filters}
            onToggleFilter={handleToggleFilter}
          />
        ))}
        <li className="space-y-2.5 pt-2">
          {STANDALONE_FILTERS.map((filter) => (
            <FilterOption
              key={filter.id}
              id={filter.id}
              label={filter.label}
              checked={filters.includes(filter.id)}
              onChange={() => handleToggleFilter(filter.id)}
            />
          ))}
        </li>
      </FilterContent>
    </FilterContainer>
  );
};
